import Globals from '~utils/Globals.js'

export const GlobalMixin = {
    data: function () {
        return {
            state: Globals.state
        }
    },
    computed: {
        isMobile: function () {
            return this.state.isMobile
        },
        isTablet: function () {
            return this.state.isTablet
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/mixins.js